import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

const rootModule = {
  state,
  mutations,
  getters,
  modules: {}
}

// 收集模块
const files = require.context('./modules/', true, /index.js/)

files.keys().forEach(key => {
  let store = files(key).default
  const moduleName = key.replace(/^\.\//, '').replace(/\/index.js$/, '')
  const modules = rootModule.modules || {}
  modules[moduleName] = store
  modules[moduleName].mutations = mutations
  modules[moduleName].namespaced = true
  rootModule.modules = modules
})

export default new Vuex.Store(rootModule)